<template>
    <el-container id="tab">
        <el-aside :width="isCollapse ? '20px' : '230px'">
            <el-card v-show="!isCollapse" class="box-card">
                <div slot="header">
                    <span>查询条件</span>
                    <el-button style="float: right; padding: 3px 0" icon="el-icon-d-arrow-left" type="text" @click="isCollapse = !isCollapse"></el-button>
                </div>
                <el-form ref="queryFormRef" :model="queryForm" :rules="queryFormRules" size="small">
                    <el-scrollbar>
                        <el-form-item label="客户" prop="customer.selected">
                            <select-multiple class="query_form_item" :select-data="queryForm.customer" :change="() => { getBalanceAmt() }" :isClear="false" isTable :column-list="selectMultipleTableColumnListCommon.customer"></select-multiple>
                        </el-form-item>
                        <el-form-item label="品牌" prop="financialBrand.selected">
                            <select-multiple class="query_form_item" ref="financialBrand" :select-data="queryForm.financialBrand" :change="() => { getBalanceAmt() }" :isClear="false"></select-multiple>
                        </el-form-item>
                        <el-form-item>
                            <p class="amt-info">
                                <span>欠款：{{ balanceAmt.arrearAmt || 0 }}元</span>
                                <span>预收：{{ balanceAmt.prePayAmt || 0 }}元</span>
                            </p>
                        </el-form-item>
                        <el-form-item label="经手人" prop="salesman.selected">
                            <select-multiple class="query_form_item" ref="salesman" :select-data="queryForm.salesman" :isClear="false"></select-multiple>
                        </el-form-item>
                        <el-form-item label="备注" prop="remark.selected">
                            <el-input v-model="queryForm.remark.selected" ref="remark" type="textarea" :autosize="{ minRows: 2 }" clearable placeholder="请输入备注"></el-input>
                        </el-form-item>
                    </el-scrollbar>
                </el-form>
            </el-card>
            <div class="is-collapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
                <span style="text-align: center;">查询</span>
                <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
                <span style="text-align: center;">条件</span>
            </div>
        </el-aside>
        <el-main>
            <div class="main-box">
                <el-form ref="form" :model="queryForm" :rules="queryFormRules" size="small" label-width="90px">
                    <el-form-item label="实收金额" prop="payAmt.selected">
                        <el-input v-model="queryForm.payAmt.selected" style="width: 240px;" @blur="inputBlur($event, 'payAmt')" @input="inputChange($event, 'payAmt')"></el-input>
                    </el-form-item>
                    <el-form-item label="折扣金额">
                        <el-input v-model="queryForm.discountAmt.selected" style="width: 240px;" @blur="inputBlur($event, 'discountAmt')" @input="inputChange($event, 'discountAmt')"></el-input>
                    </el-form-item>
                    <el-form-item label="合计金额">
                        <el-input v-model="queryForm.totalAmt.selected" style="width: 240px;" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="现金">
                        <el-input-number style="width: 240px;" class="input_number" controls-position="right" @change="inputBlur($event, 'cashsPayAmt')" v-model="queryForm.cashsPayAmt.selected" :precision="2" :min="0"></el-input-number>
                    </el-form-item>
                    <el-form-item label="支付方式">
                        <div class="item-box">
                            <select-multiple ref="account" class="dialog_select" style="width: 100px;" :select-data="queryForm.account" :isClear="false"></select-multiple>
                            <el-input-number style="width: 140px;" class="input_number" controls-position="right" @change="inputBlur($event, 'othersPayAmt')" v-model="queryForm.othersPayAmt.selected" :precision="2" :min="0"></el-input-number>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-dropdown split-button type="primary" @click="onSubmit" @command="onSubmit">
                            提交
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="A">提交并打印</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-form-item>
                </el-form>
            </div>
        </el-main>
    </el-container>
</template>
<script>
import { toRawType } from '@/assets/js/common.js'
import { g_getKeyByValue, g_getValueByKey, printSalOrder } from '@/assets/js/printByPage.js'
export default {
    components: {},
    mixins: [selectMultipleTableColumnListCommonMixins],
    data() {
        return {
            isCollapse: false,
            queryForm: {
                customer: { submitName: 'customer', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                salesman: { submitName: 'salesman', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择经手人', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                remark: { submitName: 'remark', selected: '' },
                financialBrand: { submitName: 'financialBrand', selected: { value: '2010010101010000000', text: '综合品牌' }, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: '/Account/dataSearch/selectFinanceBrandListForVueNew.html', type: 'post', params: { page: 1, size: 5, isEnabled: 'Y' }, text: '', value: '' } },
                discountAmt: { submitName: 'discountAmt', selected: 0 },
                payAmt: { submitName: 'payAmt', selected: 0 },
                cashsPayAmt: { submitName: 'cashsPayAmt', selected: 0 },
                othersPayAmt: { submitName: 'othersPayAmt', selected: 0 },
                account: { submitName: 'account', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: false, isRemote: false, isPagination: false, isReSearch: false, isDisabled: false, isClear: false, list: [], placeholder: '', request: { url: '/Account/dataSearchVue/selectAccountType.html', type: 'post', params: { page: 1, size: 100 }, text: '', value: '' } },
                totalAmt: { submitName: 'totalAmt', selected: 0 },
            },
            queryFormRules: {
                'customer.selected': [
                    { required: true, message: '请选择客户', trigger: 'blur' }
                ],
                'salesman.selected': [
                    { required: true, message: '请选择经手人', trigger: 'blur' }
                ],
                'payAmt.selected': [
                    { required: true, message: '请输入实收金额', trigger: 'blur' }
                ]
            },
            balanceAmt: {
                prePayAmt: 0,
                arrearAmt: 0
            },
            form: {

            }
        }
    },
    created() {
        // this.getUserList()
    },
    computed: {
        queryitem() {
            let tempItem = {}
            Object.values(this.queryForm).forEach(item => {
                if (toRawType(item.selected) == 'Array') {
                    tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
                } else if (toRawType(item.selected) == 'String') {
                    // if (item.submitName == 'financialBrand') {
                    //   tempItem[item.submitName + 'ID'] = '2010010101010000000'
                    //   tempItem[item.submitName + 'Name'] = '综合品牌'
                    //   return false
                    // }
                    tempItem[item.submitName] = item.selected || ''
                } else if (toRawType(item.selected) == 'Number') {
                    tempItem[item.submitName] = item.selected || 0
                } else if (toRawType(item.selected) == 'Object') {
                    if (['account', 'financialBrand', 'customer', 'salesman'].includes(item.submitName)) {
                        tempItem[item.submitName + 'ID'] = item.selected.value || ''
                        tempItem[item.submitName + 'Name'] = item.selected.text || ''
                        return false
                    }
                    tempItem[item.submitName] = item.selected.value || ''
                }
            })
            return tempItem
        }
    },
    methods: {
        async getUserList() {
            this.loading = true
            const { data: res } = await this.$http.post(this.selectUser.url, this.Qs.stringify(this.selectUser))
            this.loading = false
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            this.wareHouseList = JSON.parse(res.result.data)
            this.total = res.result.total
        },
        async getBalanceAmt() {
            console.log(this.queryitem)
            let obj = {
                customerID: this.queryitem.customerID,
                financialBrandID: this.queryitem.financialBrandID,
            }
            const { data: res } = await this.$http.post('/Account/salPayVue/queryCustomerBalanceAmt.html', this.Qs.stringify(obj))
            if (res.code != 'success') return this.$message.error(res.message)
            let data = JSON.parse(JSON.parse(res.result).data)
            this.balanceAmt = data ? data : { prePayAmt: 0, arrearAmt: 0 }
        },
        inputChange(val, tag) {
            if (val) {
                val = val.replace(/[^\d|\.]/g, '')
                this.queryForm[tag].selected = val
            }
        },
        inputBlur(e, tag) {
            this.queryForm['totalAmt'].selected = Number(this.queryForm['payAmt'].selected) + Number(this.queryForm['discountAmt'].selected)
            if (tag == 'payAmt') {
                this.queryForm['cashsPayAmt'].selected = this.queryForm[tag].selected
                this.queryForm['othersPayAmt'].selected = 0
            }
            if (tag == 'cashsPayAmt') {
                if(this.queryForm[tag].selected > this.queryForm['payAmt'].selected){
                    this.queryForm[tag].selected = this.queryForm['payAmt'].selected
                    this.$message.error('现金金额不能超过实收金额')
                }
                this.queryForm['othersPayAmt'].selected = this.queryForm['payAmt'].selected - this.queryForm[tag].selected
            }
            if (tag == 'othersPayAmt') {
                if(this.queryForm[tag].selected > this.queryForm['payAmt'].selected){
                    this.queryForm[tag].selected = this.queryForm['payAmt'].selected
                    this.$message.error('支付金额不能超过实收金额')
                }
                this.queryForm['cashsPayAmt'].selected = this.queryForm['payAmt'].selected - this.queryForm[tag].selected
            }
        },
        async onSubmit(command = '') {
            if (!this.queryitem.customerID) {
                return this.$message.error('请先选择客户')
            }
            if (!this.queryitem.salesmanID) {
                return this.$message.error('请选择经手人')
            }
            // if (Number(this.queryitem.payAmt) == 0) {
            //     return this.$message.error('实收金额不能为0')
            // }
            if (Number(this.queryitem.othersPayAmt) > 0) {
                if (this.queryitem.accountID == '') {
                    return this.$message.error('请选择支付方式')
                }
            } else {
                this.queryitem.accountID = '1001'
                this.queryitem.accountName = '现金'
            }
            console.log(this.queryitem)
            const loading = this.$loading({
                lock: true,
                text: '提交中,请等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const { data: res } = await this.$http.post('/Account/salPayVue/addRecordPrePay.html', this.Qs.stringify(this.queryitem))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            if (command == 'A') {
                if (this.$store.state.power.customPrint == 'Y') {
                    this.mouldPrintBillNo(JSON.parse(JSON.parse(res.result).data).billNo, () => {
                        setTimeout(() => {
                            top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/salPaySearch`)
                        }, 500)
                    })
                } else {
                    let url = `/Account/salPayVue/printPrePay.html?billNos=${ "'" + JSON.parse(JSON.parse(res.result).data).billNo + "'" }`
                    window.open(url, '_blank', "width=1011,height=680,left=300,top=150,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,location=no")
                    setTimeout(() => {
                        top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/salPaySearch`)
                    }, 500)
                }
            }
            setTimeout(() => {
                top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/salPaySearch`)
            }, 500)
        },
        mouldPrintBillNo(billNo, callback = () => { }) {
            let msgDom = this.$loading({
                lock: true,
                text: '打印启动中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.3)'
            });
            this.msgDomList = []
            this.msgDomList.push(msgDom)
            printSalOrder({
                billType: g_getValueByKey('SKDA'), billNos: [billNo], callback: () => {
                    if (this.msgDomList && this.msgDomList.length) {
                        this.msgDomList.forEach(item => {
                            item.close && item.close()
                        })
                        this.msgDomList = []
                    }
                    callback()
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
#tab {
    .box-card {
        display: flex;
        flex-flow: column;
        height: calc(100% - 2px);

        ::v-deep .el-card__header {
            padding: 8px 20px;
            height: 33px;
            background-color: #F5F7FA;
            color: #409EFF;
        }

        ::v-deep .el-card__body {
            padding: 6px;
            flex: 1;
            box-sizing: border-box;
            overflow-y: auto;
        }
    }

    .el-aside {
        ::v-deep .el-card__body {
            .el-form {
                height: 100%;

                .el-scrollbar {
                    height: 100%;
                }

                .el-form-item {
                    margin: 18px 0 0;
                    position: relative;

                    .el-form-item__label {
                        position: absolute;
                        z-index: 2;
                        top: -12px;
                        margin-left: 10px;
                        padding: 0 6px;
                        line-height: normal;
                        background-color: #fff;
                    }

                    .amt-info {
                        border: 1px #F56C6C solid;
                        color: #F56C6C;

                        span {
                            display: block;
                            text-align: center;
                        }
                    }
                }
            }

            .calculation-form {
                .el-form-item {
                    text-align: center;

                    .el-form-item__label {
                        margin: 0;
                        left: 36px;
                    }

                    .input-with-select {
                        .el-input-group__prepend {
                            padding: 0 12px;
                            background-color: #fff;

                            .select-multiple {
                                display: inline-block;
                                width: 50px;
                            }
                        }
                    }

                    .el-input-number .el-input__inner {
                        text-align: left;
                    }
                }
            }
        }

        .is-collapse {
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
            border: 1px #DCDFE6 solid;
            cursor: pointer;
            background-color: rgba(83, 168, 255, 0.1);
            color: #409EFF;
        }

        .select_multiple {
            ::v-deep .el-select__tags {
                max-height: 80px;
                overflow-y: auto;
                overflow-x: hidden;
            }
        }
    }

    .el-main {
        padding: 0 0 0 12px;

        .main-box {
            width: calc(100% - 42px);
            height: calc(100% - 22px);
            padding: 10px 20px;
            border: 1px solid #EBEEF5;
            border-radius: 4px;
            overflow-y: auto;
            overflow-x: hidden;

            /deep/.el-input.is-disabled {
                .el-input__inner {
                    color: #606266;
                }
            }

            /deep/.input_number {
                .el-input__inner {
                    text-align: left;
                }
            }

            .item-box {
                display: flex;
                flex-direction: row;
                align-items: center;
            }
        }
    }
}
</style>